import React from 'react';

const BS_GetStarted = () => {
    return (
        <div>
            <h1>BS_GetStarted Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_GetStarted;
